/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Link } from '@coursera/cds-core';

import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/xdp';

const styles = {
  link: css`
    color: var(--cds-color-neutral-primary) !important;
  `,
  trackedDiv: css`
    display: inline-block;
  `,
};

type Props = {
  href: string;
  trackingName: string;
  ariaLabel: string;
  target?: string;
  useBlackLink?: boolean;
  onClick?: () => void;
};

const LearnMoreLink = ({ href, trackingName, ariaLabel, target, useBlackLink = true, onClick }: Props) => (
  <TrackedDiv trackingName={trackingName} css={styles.trackedDiv}>
    <Link
      href={href}
      css={useBlackLink && styles.link}
      target={target}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
      aria-label={ariaLabel}
    >
      {_t('Learn more')}
    </Link>
  </TrackedDiv>
);

export default LearnMoreLink;
